export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 max-w-4xl mx-auto bg-background-200/70 border border-background-300/40 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">随时随地吃瓜</h2>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                关注我们的社交媒体账号，第一时间获取网红黑料推送。
                塌房翻车不再错过，吃瓜快人一步。
              </p>
              <div className="mt-6 flex flex-wrap gap-3 justify-center lg:justify-start">
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-300/70 hover:bg-background-400/50 rounded-lg cursor-pointer transition-colors duration-200 text-sm text-foreground-700 whitespace-nowrap">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-wechat-line"></i>
                  </span>
                  微信公众号
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-300/70 hover:bg-background-400/50 rounded-lg cursor-pointer transition-colors duration-200 text-sm text-foreground-700 whitespace-nowrap">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-weibo-line"></i>
                  </span>
                  微博账号
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-300/70 hover:bg-background-400/50 rounded-lg cursor-pointer transition-colors duration-200 text-sm text-foreground-700 whitespace-nowrap">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-vidicon-line"></i>
                  </span>
                  抖音号
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-48 rounded-2xl bg-background-100 border border-background-300/60 flex items-center justify-center">
                <div className="text-center">
                  <span className="w-16 h-16 flex items-center justify-center mx-auto text-primary-500">
                    <i className="ri-qr-code-line text-5xl"></i>
                  </span>
                  <p className="mt-3 text-xs text-foreground-400">扫码关注</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}